import { useEffect, useState } from 'react';
import { getLocalizedMessage } from 'src/helpers/localizations';
import type { IGasPriceModel } from '../interfaces/gas-price.model';

export function useTimer(gasPriceData: IGasPriceModel | null, localizations: any, setGasPriceApiReload: (value: string) => void) {
  const [timer, setTimer] = useState<string>('');
  useEffect(() => {
    let intervalTick = 0;

    const getTime = () => {
      const timerToEnd = (gasPriceData?.toUpdate ?? 0) - intervalTick;

      if (timerToEnd >= 0) {
        setTimer(timerToEnd.toString());
      }
      if (timerToEnd === 1) {
        setGasPriceApiReload(Math.random().toString());
      }
      const timerToString =
        timerToEnd > 60
          ? `${Math.floor(timerToEnd / 60)} ${getLocalizedMessage('calculator__time-minutes', localizations)} ${timerToEnd % 60} ${getLocalizedMessage('calculator__time-seconds', localizations)}`
          : `${timerToEnd} ${getLocalizedMessage('calculator__time-seconds', localizations)}`;
      setTimer(timerToString);

      if (timerToEnd >= 0) {
        setTimer(timerToString);
      }
      intervalTick++;
    };

    getTime();
    const interval = setInterval(getTime, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gasPriceData, setGasPriceApiReload]);
  return timer;
}
